// @flow
import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import {
  pageRouteRequiresIdentityService,
  pageRouteRequiresLicense,
} from './pageData';
import type { PageData } from './pageData';
import '../admin-styles.css';
import badge from '../../assets/badge.png';

type Props = {
  hasIdentityService: boolean,
  isFullAdmin: boolean,
  isLicensed: boolean,
  navItemClass: string,
  page: PageData,
};

export default class NavItem extends Component<Props> {
  render() {
    const {
      hasIdentityService,
      isFullAdmin,
      isLicensed,
      navItemClass,
      page,
    } = this.props;
    // Most pages require the user to be the full admin, some allow catalog admins.
    // Some pages require the server to be licensed, but catalog admins cannot retrieve licenses.
    // This leaves open a gap for catalog admins who log into an unlicensed server,
    // which is not ideal but is similar to Classic Admin behavior and an edge case.
    const isEnabled =
      (!pageRouteRequiresIdentityService.includes(page.route) ||
        hasIdentityService) &&
      (isLicensed ||
        !pageRouteRequiresLicense.includes(page.route) ||
        !isFullAdmin);
    return (
      <NavLink
        activeClassName="nav-item-selected"
        className={
          isEnabled ? navItemClass : navItemClass + ' nav-item-disabled'
        }
        data-test-name={'nav-item-' + (page.label.defaultMessage || '')}
        to={page.route}
      >
        <FormattedMessage {...page.label} />
        {page.badge && (
          <img src={badge} className="badge" alt="Unlicensed feature badge" />
        )}
      </NavLink>
    );
  }
}



// WEBPACK FOOTER //
// ./src/view/App/NavItem.js